import {
  IconBuildingStore,
  IconChartArrowsVertical,
  IconHeartHandshake,
  IconIdBadge2,
  IconSettings,
  IconShieldCheck,
  IconTruckDelivery,
  IconUsersGroup,
  type Icon,
} from '@tabler/icons-react';

export type SectionId =
  'sales' | 'operations' | 'people' | 'safety' | 'customers' | 'hr' | 'property' | 'fleet';

export interface Section {
  id: SectionId;
  label: string;
  path: string;
  icon: Icon;
  /**
   * Built and live. A section that isn't built yet stays out of the nav, the routes and the
   * "N sections hidden" count until it is, so nobody lands on a placeholder (all eight are built
   * since S-M2).
   */
  built: boolean;
}

/** The eight Aroo sections, in nav order. Icons per the handoff (Tabler, stroke 2). */
export const sections: readonly Section[] = [
  { id: 'sales', label: 'Sales', path: '/sales', icon: IconChartArrowsVertical, built: true },
  { id: 'operations', label: 'Operations', path: '/operations', icon: IconSettings, built: true },
  { id: 'people', label: 'People', path: '/people', icon: IconUsersGroup, built: true },
  { id: 'safety', label: 'Safety', path: '/safety', icon: IconShieldCheck, built: true },
  {
    id: 'customers',
    label: 'Customers',
    path: '/customers',
    icon: IconHeartHandshake,
    built: true,
  },
  { id: 'hr', label: 'HR', path: '/hr', icon: IconIdBadge2, built: true },
  { id: 'property', label: 'Property', path: '/property', icon: IconBuildingStore, built: true },
  { id: 'fleet', label: 'Fleet', path: '/fleet', icon: IconTruckDelivery, built: true },
];

/** The sections people can actually use today. */
export const builtSections: readonly Section[] = sections.filter((s) => s.built);

export function sectionById(id: SectionId): Section {
  const found = sections.find((s) => s.id === id);
  if (!found) throw new Error(`Unknown section ${id}`);
  return found;
}

/** Which section a pathname belongs to, if any (e.g. "/hr/holiday" → hr). */
export function sectionForPath(pathname: string): Section | undefined {
  const head = `/${pathname.split('/')[1] ?? ''}`;
  return sections.find((s) => s.path === head);
}
